import { Route } from '@angular/router';
import { Permissions } from 'src/app/core/common';
import { RoutesConstants } from 'src/app/shared/common';
import { RouterComponent } from 'src/app/shared/component/router/router.component';
import { PermissionGuard } from 'src/app/shared/guard/permission-guard';

export const CONTROL_SETTINGS: Route[] = [
  {
    path: RoutesConstants.GENERAL_CONFIGURATIONS_PAGE_URL,
    loadComponent: () =>
      import('./general-configurations/pages/general-configurations-pages/general-configurations-pages.component').then(
        (x) => x.GeneralConfigurationsPagesComponent
      ),
    data: {
      breadcrumb: {
        label: 'GENERAL_CONFIGURATIONS',
        icon: 'settings_applications',
      },
      permissions: [Permissions.Setting_General, Permissions.Setting_System_Config],
    },
  },
  // {
  //   path: RoutesConstants.ADD_MINUTES_PAGE_URL,
  //   loadComponent: () => import('./add-minutes/pages/add-minutes/add-minutes.component').then(x => x.AddMinutesComponent),
  //   data: {
  //     permissions: [Permissions.Setting_Add_Student_Package],
  //   }
  // },
  {
    path: RoutesConstants.CATEGORIES_PAGE_URL,
    component: RouterComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./categories/pages/categories-pages/categories-pages.component').then(
            (x) => x.CategoriesPagesComponent
          ),
        data: {
          permissions: [Permissions.Setting_Category],
        },
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./categories/pages/teacher-categories-page/teacher-categories-page.component').then(
            (x) => x.TeacherCategoriesPageComponent
          ),
        data: {
          permissions: [Permissions.Setting_Category],
        },
      },
    ],
  },
  {
    path: RoutesConstants.DISCOUNT_CODES_PAGE_URL,
    loadComponent: () =>
      import('./discount-codes/pages/discount-codes-page/discount-codes-page.component').then(
        (x) => x.DiscountCodesPageComponent
      ),
    data: {
      breadcrumb: {
        label: 'DISCOUNT_CODES',
        icon: 'money_off',
      },
      permissions: [Permissions.Setting_Add_Promo],
    },
  },
  {
    path: RoutesConstants.DYNAMIC_LINKS_PAGE_URL,
    loadComponent: () =>
      import('./dynamic-links/pages/dynamic-links/dynamic-links.component').then((x) => x.DynamicLinksComponent),
    data: {
      breadcrumb: {
        label: 'LINKS',
        icon: 'link',
      },
      permissions: [Permissions.Setting_Dynamic_Link],
    },
  },
  // {
  //   path: RoutesConstants.GET_FREE_CODES_PAGE_URL,
  //   loadComponent: () =>
  //     import('./free-codes/free-codes-page/free-codes-page.component').then((x) => x.FreeCodesPageComponent),
  //   data: {
  //     breadcrumb: {
  //       label: 'FREE_CODES',
  //       icon: 'money',
  //     },
  //     permissions: [Permissions.Setting_Add_Promo],
  //   },
  // },
  {
    path: RoutesConstants.ADS_PAGE_URL,
    loadComponent: () => import('./ads/pages/ads-page/ads-page.component').then((x) => x.AdsPageComponent),
    data: {
      breadcrumb: {
        label: 'ADS',
        icon: 'announcement',
      },
      permissions: [Permissions.Setting_Banner],
    },
  },

  // {
  //   path: RoutesConstants.PEAK_HOURS_PAGE_URL,
  //   loadComponent: () => import('./peak-hours/pages/peak-hours/peak-hours.component').then((x) => x.PeakHoursComponent),
  //   data: {
  //     breadcrumb: {
  //       label: 'PEAK_HOURS',
  //       icon: 'trending_up',
  //     },
  //     permissions: [Permissions.Setting_Peak_Hour],
  //   },
  // },
  // {
  //   path: RoutesConstants.CALL_SHARED_FILES_PAGE_URL,
  //   loadComponent: () =>
  //     import('./call-shared-files/pages/call-shared-files/call-shared-files.component').then(
  //       (x) => x.CallSharedFilesComponent
  //     ),
  //   data: {
  //     breadcrumb: {
  //       label: 'CALL_SHARED_FILES',
  //       icon: 'cloud_upload',
  //     },
  //     permissions: [Permissions.Setting_Call_Shared_Files],
  //   },
  // },
  {
    path: RoutesConstants.FAQ_CATEGORIES_PAGE_URL,
    loadComponent: () =>
      import('./faq-categories/pages/faq-categories/faq-categories.component').then((x) => x.FaqCategoriesComponent),
    data: {
      breadcrumb: {
        label: 'FAQ_CATEGORIES',
        icon: 'add_comment',
      },
      permissions: [Permissions.Setting_Help_Categories],
    },
  },
  {
    path: RoutesConstants.FAQ_PAGE_URL,
    component: RouterComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./faq/pages/faq-page/faq-page.component').then((x) => x.FaqPageComponent),
        data: {
          breadcrumb: {
            label: 'FAQ',
            icon: 'question_answer',
          },
          permissions: [Permissions.Setting_Help_FAQs],
        },
      },
      {
        path: RoutesConstants.FAQ_EDITOR_PAGE_URL,
        loadComponent: () =>
          import('./faq/components/faq-editor/faq-editor.component').then((x) => x.FaqEditorComponent),
        data: {
          breadcrumb: {
            label: 'FAQ',
            icon: 'question_answer',
          },
          permissions: [Permissions.Setting_Help_FAQs_ADD_EDIT],
        },
      },
      {
        path: RoutesConstants.FAQ_EDITOR_PAGE_URL + '/:id',
        loadComponent: () =>
          import('./faq/components/faq-editor/faq-editor.component').then((x) => x.FaqEditorComponent),
        data: {
          breadcrumb: {
            label: 'FAQ',
            icon: 'question_answer',
          },
          permissions: [Permissions.Setting_Help_FAQs_ADD_EDIT],
        },
      },
    ],
  },
  {
    path: RoutesConstants.SCHEDULED_NOTIFICATIONS_PAGE_URL,
    loadComponent: () =>
      import(
        './scheduled-notifications/pages/scheduled-notifications-table/scheduled-notifications-table.component'
      ).then((x) => x.ScheduledNotificationsTableComponent),
    data: {
      breadcrumb: {
        label: 'SCHEDULED_NOTIFICATIONS',
        icon: 'notifications',
      },
      permissions: [Permissions.Reports_NotificationReport],
    },
  },
];

for (const route of CONTROL_SETTINGS) {
  route.canActivate = [PermissionGuard];
}
